import styled from 'styled-components';
import { Alert, ListItemButton } from '@mui/material';
import { hoverOpacity } from '@shared/styledComponents';
import { colorTheme } from '@styles/muiTheme';

export const ReminderRow = styled(ListItemButton)`
  display: flex;
  padding-right: 4px;
  align-items: center;
  justify-content: space-between;

  .MuiSelect-select {
    padding-top: 0px
  }
`;

export const ReminderRowGroup = styled.div`
  display: flex;
  width: 150px;

  .MuiFormControl-root {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .MuiInputBase-root {
      background: ${({ theme }) => theme.palette.primary.dark}; 
    }

    #snooze-select-label {
      top: -3px;
      color: ${({ theme }) => theme.palette.common.white};
    }
    #snooze-label {
      width: 150px;
      background: ${({ theme }) => theme.palette.primary.dark};
      color: ${({ theme }) => theme.palette.common.white};
    }
    svg.MuiSelect-icon {
      fill: ${({ theme }) => theme.palette.common.white};
    }
  }
`;

export const ReminderDetails = styled(ReminderRowGroup)`
  flex-direction: column;
  align-items: flex-start;
`;

export const ReminderFooter = styled.span`
  display: flex;
  color: ${({ theme }) => theme.palette.info.dark};
  font-size: 14px;
  font-weight: 700;
  padding: 8px 16px;
  cursor: pointer;

  ${hoverOpacity};
`;

export const ButtonWrapper = styled(ReminderFooter) <{ isAllBtn: boolean }>`
  position: absolute;
  top: 5px;
  left: ${({ isAllBtn }) => (isAllBtn ? '240px' : '200px')};
`;

export const NotificationRow = styled(ListItemButton)`
  display: flex;
  padding: 5px 13px 5px 6px;
  position: relative;
  cursor: default;
`;

export const NotificationRowGroup = styled.div`
  gap: 3px;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  flex: 1;

  .MuiIconButton-root {
    margin: -5px -7px 0 0;
  }
`;

export const NotificationDetails = styled(NotificationRowGroup)`
  align-items: flex-start;
  flex: 1;
`;

export const MarkAllRead = styled.span`
  position: absolute;
  cursor: pointer;
  top: 15px;
  right: 42px;

  ${hoverOpacity};
`;

export const TextWrapper = styled.div`
  cursor: pointer;
`;

export const StyledCustomAlert = styled(Alert)`
  position: absolute;
  top: 20px;
  right: 20px;
  width: auto;
  z-index: 10;
  background: ${colorTheme.palette.error.dark};
`;